interface DumelInstagramData {
  attribution: null;
  caption: any[];
  comments: any;
  created_time: string;
  filter: string;
  id: string;
  images: any;
  likes: any;
  link: string;
  location: any;
  tags: any[];
  type: string;
  user: any;
  user_has_liked: boolean;
  users_in_photo: any[];
}

interface DumelInstagramMeta {
  code: number;
}

interface DumelInstagram {
  data: DumelInstagramData[];
  meta: DumelInstagramMeta;
  pagination: any;
}

class DumelInstagram {
  private element: JQuery;
  private token: string;

  constructor(element: JQuery) {
    this.element = element;
    this.token = this.getToken();

    this.downloadInstagramData()
      .then((data: DumelInstagram) => {
        data.data.forEach((item) => {
          this.buildInstagramHtml(item);
        });
      });
  }

  private buildInstagramHtml(data: DumelInstagramData) {
    const mediaItem = $(`<a target="_blank" class="cms-dumel-instagram__media-item" href="${data.link}">
      <img class="cms-dumel-instagram__media-item-image" src="${data.images.low_resolution.url}"/>
    </a>`);

    if (data.type === 'video') {
      mediaItem.append(`<svg class="cms-dumel-instagram__media-item-video-icon" viewBox="0 0 86.8 52">
        <path d="M83.7,6.2c-2-1.1-4.4-1.1-6.3,0l-15.6,9V8.4C61.8,3.8,58,0,53.4,0h-45C3.8,0,0,3.8,0,8.4v35.2C0,48.2,3.8,52,8.4,52h45
          c4.6,0,8.4-3.8,8.4-8.4v-6.8l15.6,9c3,1.7,6.9,0.7,8.6-2.3c0.6-1,0.8-2,0.8-3.2V11.7C86.9,9.5,85.7,7.4,83.7,6.2z M82.7,11.7v28.6
          c0,0.6-0.2,1.1-0.6,1.5s-0.9,0.6-1.5,0.6c-0.4,0-0.8-0.1-1.1-0.3L61.8,31.9V20.1L79.5,9.9c0.5-0.3,1.1-0.4,1.6-0.2
          c0.6,0.2,1,0.5,1.3,1C82.6,11,82.7,11.3,82.7,11.7z M57.6,8.4v35.2c0,2.4-1.9,4.3-4.3,4.3h-45C5.9,47.9,4,46,4,43.6V8.4
          c0-1.1,0.4-2.2,1.2-3s1.9-1.3,3-1.3h45C55.7,4.1,57.6,6,57.6,8.4z"/>
      </svg>`);
    }

    $(this.element).find('.cms-dumel-instagram__media').append(mediaItem);
  }

  private downloadInstagramData() {
    return $.get('https://api.instagram.com/v1/users/self/media/recent/?access_token=' + this.token + '&count=8');
  }

  private getToken(): string {
    const tokenElement = this.element.find('.cms-dumel-instagram');
    const api = tokenElement.attr('data-token');

    tokenElement.removeAttr('data-token');

    return api;
  }
}

$(document).ready(() => {
  $('dumel-instagram').each((index, element) => {
    const instance = new DumelInstagram($(element));
  });
});
